import i18n from "@/core/plugins/i18n";
import {
  IRecommendationRange,
  RecommendationParamEnum,
} from "../models/recommendation.model";
import { HMIKeyType } from "../models/hmi.model";

export const VALIDATION_RULES = {
  required: (value: any) => {
    if (value === undefined || value === null) return i18n.t("required");
    return true;
  },
  range: (value: number, min?: number, max?: number) => {
    if ((min && value < min) || (max && value > max)) {
      return i18n.t("rangeError", { min, max });
    }
    return true;
  },
};

export const EMPTY_STRING = "--";

export const RECOMMENDATION_RANGES: Record<
  keyof typeof RecommendationParamEnum,
  IRecommendationRange
> = {
  carbon: {
    min: 1,
    max: 3.5,
  },
  metallization: {
    min: 88,
    max: 95,
  },
  productionRate: {
    min: 70,
    max: 130,
  },
};

export const RECOMMENDATION_UNIT: Record<
  keyof typeof RecommendationParamEnum,
  string
> = {
  carbon: "%",
  metallization: "%",
  productionRate: "t/h",
};

export const HMI_UNITS: Partial<Record<HMIKeyType, string>> = {
  PT_X101_1: "bar",
  PT_X101_2: "bar",
  PT_X171: "bar",
  PT_X179_2: "bar",
  TT_X317_1: "°C",
  TT_X317_3: "°C",
  TT_X317_7: "°C",
  TT_X317_9: "°C",
  TT_X180_1: "°C",
  TT_X180_2: "°C",
  TT_X181_1: "°C",
  TT_X181_2: "°C",
  TT_X174: "°C",
  TT_X221_2: "°C",
  TT_X221_3: "°C",
  TT_X221_4: "°C",
  TT_X221_5: "°C",
  TT_X216_1: "°C",
  TT_X216_2: "°C",
  TT_X219_1: "°C",
  TT_X219_2: "°C",
  ZT_X307: "%",
  FT_X823: "m³/h³",
  WT_X641: "t/h",
  FR_X119_1: "Nm³/h",
};
